export enum PregledRezervacijaTabEnum {
    Spot = 'spot',
    Ugovor = 'ugovor'
}


// WEBPACK FOOTER //
// ./src/app/pages/rezervacije/enums/pregled-rezervacija-tab.enum.ts